export const injectGoogleTagManager = async (context: Window, containerId: string) => {
    if (containerId == null) {
        return Promise.reject(new Error('No containerId'));
    }
    if (context?.google_tag_manager?.[containerId] == null) {
        return loadGtm(context, containerId);
    }

    return Promise.resolve();
};

const loadGtm = async (context: Window, gtmId: string) =>
    new Promise<void>((resolve, reject) => {
        context.dataLayer = context.dataLayer || [];
        context.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

        const firstScript = context.document.getElementsByTagName('script')[0];
        const scriptElement = context.document.createElement('script');

        scriptElement.onload = () => resolve();
        scriptElement.onerror = (err) => reject(err);
        scriptElement.async = true;
        scriptElement.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
        firstScript.parentNode?.insertBefore(scriptElement, firstScript);
    });
